import React from 'react'
import Footer from './Footer';
import Header from './Header';

function Contact() {

  return (
	<div className='contact'>
		<Header />
			<div className="contactbody">
				<h1 className='h1heading'>Contact</h1>
					<div className="grid-contain">
						<div className="grid1">
							<p>condimentum mattis pellentesque id nibh tortor. Integer vitae justo eget magna fermentum iaculis eu non. Penatibus et magnis dis parturient montes nascetur ridiculus. Elementum pulvinar etiam non quam lacus suspendisse faucibus. Lacinia at quis risus sed.</p>
							<p>Aliquam nulla facilisi cras fermentum. A pellentesque sit amet porttitor. Aliquet nec ullamcorper sit amet risus nullam eget. Dignissim diam</p>
							<p>Vitae proin sagittis nisl rhoncus mattis rhoncus urna. Ac tincidunt vitae semper quis lectus. Lorem ipsum dolor sit amet consectetur adipiscing elit ut aliquam.</p>
						</div>
						<div className="grid2">
						<p>condimentum mattis pellentesque id nibh tortor. Integer vitae justo eget magna fermentum iaculis eu non. Penatibus et magnis dis parturient montes nascetur ridiculus. Elementum pulvinar etiam non quam lacus suspendisse faucibus. Lacinia at quis risus sed.</p>
							<p>Aliquam nulla facilisi cras fermentum. A pellentesque sit amet porttitor. Aliquet nec ullamcorper sit amet risus nullam eget. Dignissim diam</p>
							<p>Vitae proin sagittis nisl rhoncus mattis rhoncus urna. Ac tincidunt vitae semper quis lectus. Lorem ipsum dolor sit amet consectetur adipiscing elit ut aliquam.</p>
						</div>
					</div>
			</div>
			<Footer />
	</div>
  )
}

export default Contact